// src/api/date.constants.ts

import 'fix-date'

export const userLocales = 'de-DE'

const D2: Intl.DateTimeFormatOptions['day'] = '2-digit'
const L: Intl.DateTimeFormatOptions['month'] = 'long'
const N: Intl.DateTimeFormatOptions['year'] = 'numeric'
const S: Intl.DateTimeFormatOptions['weekday'] = 'short'

// 01.01.70
export const WD = { weekday: S }
// 01.01.70
export const DDMMYY = { day: D2, month: D2, year: D2 }
// 01.01.1970
export const DDMMYYYY = { day: D2, month: D2, year: N }
// 1. Januar 1970
export const DMMMMYYYY = { day: N, month: L, year: N }
// Montag, 01.01.70
export const WDDDMMYY = { weekday: S, day: D2, month: D2, year: D2 }
// Montag, 01.01.1970
export const WDDDMMYYYY = { weekday: S, day: D2, month: D2, year: N }
// 1. Januar 1970 00:00:00
export const DMMMMYYYYHHMMSS = {
  day: N,
  hour: D2,
  minute: D2,
  month: L,
  second: D2,
  year: N,
}
// Montag, 01.01.1970 00:00:00
export const WDDDMMYYYYHHMMSS = {
  weekday: S,
  day: D2,
  month: D2,
  year: N,
  hour: D2,
  minute: D2,
  second: D2,
}
// Montag, 01.01.1970 00:00:00
export const WDDDMMYYHHMM = {
  weekday: S,
  day: D2,
  month: D2,
  year: D2,
  hour: D2,
  minute: D2,
}
// Montag, 01.01.1970 00:00:00
export const WDDDMMYYYYHHMM = {
  weekday: S,
  day: D2,
  month: D2,
  year: N,
  hour: D2,
  minute: D2,
}
// 01.01.70 00:00
export const DDMMYYHHMM = { day: D2, month: D2, year: D2, hour: D2, minute: D2 }
// 01.01.1970 00:00
export const DDMMYYYYHHMM = {
  day: D2,
  month: D2,
  year: N,
  hour: D2,
  minute: D2,
}
// 01.01.1970 00:00:00
export const DDMMYYYYHHMMSS = {
  day: D2,
  hour: D2,
  minute: D2,
  month: D2,
  second: D2,
  year: N,
}
// 00:00
export const HHMM = { hour: D2, minute: D2 }
// 00:00:00
export const HHMMSS = { hour: D2, minute: D2, second: D2 }
// 01. Januar
export const DDMMMM = { day: D2, month: L }
// 01.01.
export const DDMM = { day: D2, month: D2 }
// 1970
export const YYYY = { year: N }
// Januar
export const MMMM = { month: L }
// Jan 70
export const MMMYY = { month: S, year: D2 }
//
export const MMMMYYYY = { month: L, year: N }
// 1.
export const D = { day: N }
// 1. Jan 00:00
export const DMMMHHMM = { day: N, month: S, hour: D2, minute: D2 }
// 1. Januar 00:00
export const DMMMMHHMM = { day: N, month: L, hour: D2, minute: D2 }

// get current year, month or day
export const currentYear = new Date().toLocaleString(userLocales, YYYY)
export const currentMonth = new Date().toLocaleString(userLocales, MMMM)
export const currentDay = new Date().toLocaleString(userLocales, D)

// Uhrzeit von einem Datums-Objekt liefern
export const timeOfDay = (date: string | number | Date) =>
  new Date(date).toLocaleString(userLocales, HHMMSS)

export const A_MONTH_AGO = (() => {
  const d = new Date()
  d.setMonth(d.getMonth() - 1)
  return d
})()

export const hoursAgo = (date, hours) =>
  new Date(new Date(date).getTime() - 1000 * 60 * 60 * hours).toLocaleString(
    'sv-SE'
  )

export const hoursOnward = (date, hours) =>
  new Date(new Date(date).getTime() + 1000 * 60 * 60 * hours).toLocaleString(
    'sv-SE'
  )

export const daysAgo = (date: string | number | Date, days: number) =>
  new Date(new Date(date).getTime() - 1000 * 60 * 60 * 24 * days)
    .toISOString()
    .split('T')[0]

export const daysOnward = (date: string | number | Date, days: number) =>
  new Date(new Date(date).getTime() + 1000 * 60 * 60 * 24 * days)
    .toISOString()
    .split('T')[0]

export const monthsAgo = (
  date: string | number | Date,
  numberOfMonths: number,
  firstOfMonth?: boolean
) => {
  date = new Date(date)
  date.setDate(1)
  date.setMonth(date.getMonth() - numberOfMonths)

  if (!firstOfMonth) {
    date = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    date.setDate(date.getDate() + 1)
  }

  return date.toISOString().split('T')[0]
}

export const monthsOnward = (
  date: string | number | Date,
  numberOfMonths: number,
  firstOfMonth?: boolean
) => {
  date = new Date(date)
  date.setDate(1)
  date.setMonth(date.getMonth() + numberOfMonths)

  if (!firstOfMonth) {
    date = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    date.setDate(date.getDate() + 1)
  }

  return date.toISOString().split('T')[0]
}

export const noDecimals = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}

export const germanDecimals = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}

const RELATIVE_DATE_CONDITIONS = [
  { check: delta => delta < 60, result: 'vor ein paar Sekunden' },
  { check: delta => delta < 120, result: 'vor 1 Minute' },
  {
    check: delta => delta < 3600,
    result: delta => `vor ${Math.floor(delta / 60)} Minuten`,
  },
  { check: delta => Math.floor(delta / 3600) === 1, result: 'vor 1 Stunde' },
  {
    check: delta => delta < 86400,
    result: delta => `vor ${Math.floor(delta / 3600)} Stunden`,
  },
  { check: delta => delta < 86400 * 2, result: 'gestern' },
  { check: delta => delta < 86400 * 3, result: 'vorgestern' },
  { check: delta => delta < 604800, result: 'vor 1 Woche' },
  { check: delta => delta < 604800 * 2, result: 'vor 2 Wochen' },
  { check: delta => delta < 604800 * 3, result: 'vor 3 Wochen' },
  { check: delta => delta < 604800 * 4, result: 'vor 4 Wochen' },
  { check: delta => delta < 86400 * 30, result: 'vor über 30 Tagen' },
  { check: delta => delta < 86400 * 60, result: 'vor über 60 Tagen' },
  { check: delta => delta < 86400 * 90, result: 'vor über 90 Tagen' },
  { check: delta => delta < 86400 * 180, result: 'vor über 180 Tagen' },
  { check: delta => delta < 86400 * 365, result: 'vor über 1 Jahr' },
  { check: delta => delta < 86400 * 730, result: 'vor über 2 Jahren' },
  { check: delta => delta < 86400 * 1095, result: 'vor über 3 Jahren' },
  { check: delta => delta < 86400 * 1460, result: 'vor über 4 Jahren' },
  { check: delta => delta < 86400 * 1825, result: 'vor über 5 Jahren' },
]

export const getRelativeDate = (date: string | number | Date) => {
  const delta = Math.round(
    (new Date().getTime() - new Date(date).getTime()) / 1000
  )
  for (const cond of RELATIVE_DATE_CONDITIONS) {
    if (cond.check(delta)) {
      return typeof cond.result === 'function'
        ? cond.result(delta)
        : cond.result
    }
  }
  return date
}

// get full array of days with every hour between two dates
export const getHoursArray = (
  startDate: string | number | Date,
  endDate: string | number | Date
) => {
  const start = new Date(startDate)
  const end = new Date(endDate)
  const now = new Date()

  start.setMinutes(0, 0, 0)
  end.setMinutes(0, 0, 0)

  const last = new Date(Math.min(end.getTime(), now.getTime()))
  const hours = []
  for (let t = start; t <= last; t = new Date(t.getTime() + 60 * 60 * 1000))
    hours.push(t)

  return hours
}

// get full array of days between two dates
export const getDaysArray = (
  startDate: string | number | Date,
  endDate: string | number | Date
) => {
  const daysArray = []
  const date = new Date(startDate)

  for (
    daysArray;
    date.getTime() <= new Date(endDate).getTime();
    date.setDate(date.getDate() + 1)
  )
    daysArray.push([new Date(date).toISOString().split('T')[0]])

  return daysArray
}

// get full array of months between two dates
export const getMonthsArray = (startDate: string, endDate: string) => {
  const start = startDate.split('-')
  const end = endDate.split('-')
  const startYear = Number(start[0])
  const endYear = Number(end[0])
  const dates = []

  for (let yearIndex = startYear; yearIndex <= endYear; yearIndex++) {
    const endMonth = yearIndex !== endYear ? 11 : Number(end[1]) - 1
    const startMon = yearIndex === startYear ? Number(start[1]) - 1 : 0

    for (
      let monthIndex = startMon;
      monthIndex <= endMonth;
      monthIndex = monthIndex > 12 ? monthIndex % 12 || 11 : monthIndex + 1
    ) {
      const month = monthIndex + 1
      const displayMonth = month < 10 ? '0' + month : month

      dates.push(new Date([yearIndex, displayMonth, '01'].join('-')))
    }
  }

  return dates
}

// get full array of years between two dates
export const getYearsArray = (
  startDate: string | number = '2018',
  endDate: string | number = '2025'
) => {
  const startYearNum = Number(String(startDate).substring(0, 4))
  const endYear = Number(String(endDate).substring(0, 4))
  let startYear = startYearNum
  const years = []

  for (let i = startYear; i <= endYear; i++) {
    years.push([new Date(`${startYear}-01-01`)])
    startYear++
  }

  return years
}

// add the weekday to an array of dates
export const addWeekdays = (
  daysArray: Array<[string]>,
  granularity: 'd' | 'm' | 'y'
) => {
  if (granularity !== 'y') {
    daysArray = daysArray.map(_day => {
      if (typeof _day[0] === 'string' && _day[0].includes('.')) {
        let weekDay = _day[0].split('.')
        if (granularity === 'd') weekDay = _day[0].substring(0, 10).split('.')

        const weekDayDate = new Date(
          Number(`20${weekDay[2]}`),
          Number(weekDay[1]) - 1,
          Number(weekDay[0])
        )

        _day[0] = `${weekDayDate.toLocaleString(userLocales, WD)}, ${_day[0]} `
      }
      return _day
    })
  }
  return daysArray
}

export const isFullMonth = (dateFrom, dateTo) => {
  dateFrom = new Date(dateFrom)
  dateTo = new Date(dateTo)

  const isLastDay = (year, month) => new Date(year, month + 1, 0).getDate()

  if (dateFrom.getDate() !== 1) return false

  return dateTo.getDate() === isLastDay(dateTo.getFullYear(), dateTo.getMonth())
    ? true
    : false
}

export const isMoreThenSevenDays = (dateFrom, dateTo) => {
  dateFrom = new Date(dateFrom)
  dateTo = new Date(dateTo)

  const range = dateTo.getTime() - dateFrom.getTime()
  const difference = range / (1000 * 60 * 60 * 24)

  return difference > 7 ? true : false
}

export const isMoreThenSixMonths = (dateFrom, dateTo) => {
  const from = new Date(dateFrom)
  const to = new Date(dateTo)
  const monthsDiff =
    (to.getFullYear() - from.getFullYear()) * 12 +
    (to.getMonth() - from.getMonth())
  return monthsDiff > 6 || (monthsDiff === 6 && to.getDate() >= from.getDate())
}

// YYYY-MM-DD
export const toDateFormat = str => str?.split('T')[0] ?? ''

// YYYY-MM-DDTHH:00
export const toDateTimeLocal = str => {
  if (!str) return ''

  // "2026-01-27T08:00:00" -> "2026-01-27T08:00"
  if (str.includes('T')) return str.slice(0, 16)

  // "2026-01-27 04:00:00" -> "2026-01-27T04:00"
  if (str.includes(' ')) return str.replace(' ', 'T').slice(0, 16)

  // "2026-01-27" -> "2026-01-27T00:00"
  return `${str}T00:00`
}

const pad = (n: number) => String(n).padStart(2, '0')

export const limitNowAsMax = (
  date: string,
  granularity: string,
  mode: 'from' | 'to'
) => {
  if (!date) return date

  const now = new Date()
  const currentYear = String(now.getFullYear())
  const selectedYear = date.slice(0, 4)

  if (granularity === 'yy' && mode === 'to' && selectedYear === currentYear)
    return `${currentYear}-12-31T23:59:59`

  const nowDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
  const nowHour = `${nowDate}T${pad(now.getHours())}:00:00`

  const max = granularity === 'd' ? nowHour : nowDate

  return date > max ? max : date
}

export const clampToLastFullMonth = (date: string) => {
  if (!date) return date

  const now = new Date()
  const lastFullMonth = new Date(now.getFullYear(), now.getMonth(), 0)

  const y = lastFullMonth.getFullYear()
  const m = String(lastFullMonth.getMonth() + 1).padStart(2, '0')
  const d = String(lastFullMonth.getDate()).padStart(2, '0')

  const lastFullMonthEnd = `${y}-${m}-${d}`

  return date > lastFullMonthEnd ? lastFullMonthEnd : date
}
